<template>
    <div>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block v-b-toggle.privacy-section-6 class="text-left fw-500">6. Security and Fraud Prevention</b-button>
            </b-card-header>
            <b-collapse id="privacy-section-6" visible accordion="my-accordion" role="tabpanel">
                <b-card-body>
                    <ol>
                        <li>Security Measures: RCPAY Virtual Account employs advanced security measures to protect VAs, including encryption and two-factor authentication.</li>
                        <li>User Responsibilities: The Account Holder is responsible for maintaining the confidentiality of their login credentials and must not share them with third parties.</li>
                        <li>Reporting Unauthorized Activity: Any suspected unauthorized activity must be reported to RCPAY Virtual Account immediately. The Platform will investigate and take appropriate action.</li>
                    </ol>
                </b-card-body>
            </b-collapse>
        </b-card>
      
    </div>
</template>

<script>
  
export default {
    name: 'section-6',
    data() {
        return {
        publicPath      : process.env.BASE_URL!='/'?process.env.BASE_URL:''
        };
    }
};
</script>